export const normalizePartnerMappingError = (rawData) => {
  if (!rawData || !rawData?.data) {
    return {
      ...rawData,
      isError: true,
      data: undefined,
    }
  }
  const { code, message } = rawData.data
  return {
    ...rawData,
    isError: true,
    data: {
      errorCode: code,
      errorMessage: message,
    },
  }
}

export const normalizePartnerMappingProduct = (rawData) => {
  if (!rawData || !rawData?.data) {
    return {
      ...rawData,
      date: undefined,
    }
  }
  const {
    product_name: productName,
    product_description: productDescription,
    title_description: titleDescription,
    duration,
    next_payment_date: nextPaymentDate,
    in_use_product: inUseProduct,
    in_use_product_name: inUseProductName,
    in_use_product_description: inUseProductDescription,
    in_use_title_description: inUseTitleDescription,
  } = rawData.data
  return {
    ...rawData,
    data: {
      productName,
      productDescription,
      titleDescription,
      duration,
      nextPaymentDate,
      inUseProduct,
      inUseProductName,
      inUseProductDescription,
      inUseTitleDescription,
    },
  }
}
